import React from 'react'
import './add-new-town-popup.css'

import Axios from 'axios'
import { baseUrl } from '../../assets/Animations'

const AddNewTownPopup = (props) => {
    const [townName, setTownName] = React.useState('')
    const [uri, setUri] = React.useState('')
    const [abbr, setAbbr] = React.useState('')
    const [insts, setInsts] = React.useState([])
    const [addInst, setAddInst] = React.useState(false)


    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }


    const tryToClose = (tar) => {
        if(tar === 'add-new-town-popup-wrapper') {
            props.setAddNewTown(false)
        }
    }
    const setSelectedInst = (id) => {
        const inst = props.instruments.find(u => u.id === id);
        setAddInst({
            id: inst.id,
            name: inst.name,
            uri: inst.uri,
            copy: [],
            faqs: [],
            video: {
              name: '',
              description: '',
              thumbnailUrl: '',
              uploadDate: '',
              embedUrl: '',
              hasPart: []
            }
        })
    }

    const addCopySection = () => {
        let myInst = addInst
        myInst.copy.push({id: Math.random().toString(16).slice(2), text:''})
        setAddInst({...myInst})
    }
    const addFAQSection = () => {
        let myInst = addInst
        myInst.faqs.push({id: Math.random().toString(16).slice(2), question:'', answer: ''})
        setAddInst({...myInst})
    }

    const changeCopy = (id, val) => {
        let myInst = addInst
        for(let i = 0; i < myInst.copy.length; i++) {
            if(myInst.copy[i].id === id) {
                myInst.copy[i].text = val
            }
        }
        setAddInst({...myInst})
    }

    const changeFAQ = (id, val, qora) => {
        let myInst = addInst
        for(let i = 0; i < myInst.faqs.length; i++) {
            if(myInst.faqs[i].id === id) {
                if(qora === 'question') {
                    myInst.faqs[i].question = val
                } else if (qora === 'answer') {
                    myInst.faqs[i].answer = val
                }

            }
        }
        setAddInst({...myInst})
    }

    const saveNewInstrument = () => {
        let myInsts = insts
        let changed = false
        for(let i = 0; i < myInsts.length; i++) {
            if(myInsts[i].id === addInst.id) {
                myInsts[i] = addInst
                changed = true
            }
        }
        if(changed) {
            setInsts([...myInsts])
            setAddInst(false)
        } else {
            setInsts([...myInsts, addInst])
            setAddInst(false)
        }
    }

    const editInstrument = (id) => {
        let instToEdit = insts.find((inst) => inst.id === id)
        setAddInst(instToEdit)
    }

    const changeVideoUrl = (val) => {
        setAddInst({...addInst, videoUrl: val})
    }

    const submitNewTown = () => {
        Axios.post(`${baseUrl}/town`, {
            town: {
                id: Math.random().toString(16).slice(2),
                townName: townName,
                townUri: uri,
                schoolAbbreviation: abbr,
                instruments: insts,
            }
        }, myHeader)
        .then((res) => {
            props.setAddNewTown(false)
            props.setTowns(prev => [...prev, res.data])
        })
        .catch((err) => {
            console.log(err)
        })
    }

    return(
        <div className='add-new-town-popup-wrapper' id='add-new-town-popup-wrapper' onClick={(e) => tryToClose(e.target.id)}>
            <div className='add-new-town-popup'>
                <h2>Create A Town</h2>
                <div className='add-new-town-input__wrapper'>
                    <h5>Town Name</h5>
                    <input className='add-new-town-popup-inputs' placeholder='Town Name' value={townName} onChange={(e) => setTownName(e.target.value)} />
                </div>
                <div className='add-new-town-input__wrapper'>
                    <h5>URI</h5>
                    <input className='add-new-town-popup-inputs' placeholder='URI' value={uri} onChange={(e) => setUri(e.target.value)} />
                </div>
                <div className='add-new-town-input__wrapper'>
                    <h5>School Abbreviation</h5>
                    <input className='add-new-town-popup-inputs' placeholder='School Abbr' value={abbr} onChange={(e) => setAbbr(e.target.value)} />
                </div>
                {insts.map((inst) => <div key={inst.id} onClick={() => editInstrument(inst.id)}>{inst.name}</div>)}
                <div className='add-new-town-add-btn-wrapper'>
                    <div className='add-new-town-add-btn' onClick={() => setAddInst({})}>+ Add Instrument</div>
                </div>
                <div>
                    <div className='add-new-town-save-btn' onClick={() => submitNewTown()}>SAVE TOWN</div>
                </div>
            </div>



            {/* ADD INSTRUMENT POPUP WINDOW! */}
            {
                addInst && 
                <div className='add-new-town-instrument-popup'>
                    <div onClick={() => setAddInst(false)}>Close</div>
                    <select value={addInst.id} onChange={(e) => setSelectedInst(e.target.value)}>
                        <option value={{}}>NONE</option>
                        {props.instruments.map((inst) => <option key={inst.id} value={inst.id}>{inst.name}</option>)}
                    </select>
                    {   addInst.id &&
                        <div>
                            {addInst.copy.map((copy) => <textarea key={copy.id} value={copy.text} onChange={(e) => changeCopy(copy.id, e.target.value)} />)}
                            <div className='add-new-town-instrument-popup__add-copy-btn' onClick={() => addCopySection()}>+ Add Copy Section</div>
                            {addInst.faqs.map((faq) => 
                                <div key={faq.id}>
                                    <input  value={faq.question} onChange={(e) => changeFAQ(faq.id, e.target.value, 'question')} />
                                    <textarea  value={faq.answer} onChange={(e) => changeFAQ(faq.id, e.target.value, 'answer')} />
                                </div>
                            )}
                            <div className='add-new-town-instrument-popup__add-copy-btn' onClick={() => addFAQSection()}>+ Add FAQ Section</div>
                            <input className='add-new-town-popup-inputs' placeholder='Video Url' value={addInst.videoUrl} onChange={(e) => changeVideoUrl(e.target.value)} />
                            <div className='add-new-town-instrument-popup__save-btn' onClick={() => saveNewInstrument()}>Save Instrument</div>
                        </div>
                    }
                </div>
            }
            {/* ------------------------ */}


        </div>
    )
}
export default AddNewTownPopup